<!--<h2 mat-dialog-title i18n="@@UI.Label.SetPassword.Title">Jelszó módosítás</h2>-->
<div class="password-change-wrapper">
  <div [formGroup]="passwordForm" class="password-fields">
    <mat-form-field [appearance]="appearance">
      <mat-label i18n="@@UI.Label.SetPassword.NewPassword">Új jelszó</mat-label>
      <input autofocus matInput [type]="hide ? 'password' : 'text'" name="password1" formControlName="password1" (keydown.enter)="enterEvent()" #firstPasswordInput />
      <span matIconSuffix (click)="hide = !hide" class="material-symbols-rounded show-hide-icon">{{hide ? 'visibility_off' : 'visibility'}}</span>
    </mat-form-field>

    <mat-form-field [appearance]="appearance">
      <mat-label i18n="@@UI.Label.SetPassword.NewPasswordConfirm">Új jelszó még egyszer</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" name="password2" formControlName="password2" (keydown.enter)="enterEvent()" />
      <span matIconSuffix (click)="hide = !hide" class="material-symbols-rounded show-hide-icon">{{hide ? 'visibility_off' : 'visibility'}}</span>
    </mat-form-field>
  </div>
  <div class="errors">
    @if (requirementstitle) {
      <h4 i18n="@@UI.Label.SetPassword.RestrictionsTitle">Új jelszó kötelező jellemzői:</h4>
    }
    <div class="requirement" [class.ok]="requirementIsOK('minlength')">
      <span class="material-symbols-rounded">{{requirementIcon('minlength')}}</span>
      @if (isDarkMode && requirementIcon('minlength') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span i18n="@@UI.Label.Common.Error.MinLength">Legalább {{ 6 //i18n(ph="value") }} karakter</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('lowercaseLetter')">
      <span class="material-symbols-rounded">{{requirementIcon('lowercaseLetter')}}</span>
      @if (isDarkMode && requirementIcon('lowercaseLetter') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span i18n="@@UI.Label.Common.Error.LowerCaseLetter">Kisbetűt tartalmaz</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('uppercaseLetter')">
      <span class="material-symbols-rounded">{{requirementIcon('uppercaseLetter')}}</span>
      @if (isDarkMode && requirementIcon('uppercaseLetter') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span i18n="@@UI.Label.Common.Error.UpperCaseLetter">Nagybetűt tartalmaz</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('containsNumber')">
      <span class="material-symbols-rounded">{{requirementIcon('containsNumber')}}</span>
      @if (isDarkMode && requirementIcon('containsNumber') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span i18n="@@UI.Label.Common.Error.ContainsNumber">Számot tartalmaz</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('confirmPassword', true)">
      <span class="material-symbols-rounded">{{requirementIcon('confirmPassword', true)}}</span>
      @if (isDarkMode && requirementIcon('confirmPassword', true) === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span i18n="@@UI.Label.Error.ConfirmPasswordMustMatch">A két jelszó megegyezik!</span>
    </div>
  </div>
</div>
